import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { DateToString } from "components/Reports/DateFilter";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useAppSelector } from "store/store";

export default function ReturnedChequeForm(props: any) {
  const store = useAppSelector((x) => x);
  const persons = store.personReducer.allPerson;
  const form = useFormikContext();
  const values: any = form.values;
  useEffect(() => {
    !values.date && form.setFieldValue("date", DateToString(new Date(Date.now())));
  }, []);
  const status = props?.status;
  return (
    <div className="flex flex-col p-2 gap-6">
      <BasicDateInput
        label="تاریخ"
        onChange={(dates) => dates && form.setFieldValue("date", dates[0])}
        required
        withoutClear
        styles={{ container: { width: 200 } }}
        defaultValues={[values?.date]}
      />
      {/* {status === "paidRefund" && (
        // <BasicSelect
        //   options={persons}
        //   onChange={(val) => form.setFieldValue("personId", val)}
        //   withSearch
        //   label="شخص"
        //   required
        // />
      )} */}
      <BasicTextInput
        textArea
        label="توضیحات"
        onChange={(val) => form.setFieldValue("description", val)}
        val={values.description}
        required
      />
    </div>
  );
}
